import { products } from '../../resource/Products';
import { Accordion } from 'react-bootstrap';
import Product from './Product';

function Contents(props) {
  const { section, selection } = props;
  function select() {
    if (section === 'category') {
      return products.filter((product) =>
        product.categories.includes(selection[0].id)
      );
    } else if (section === 'ingredient') {
      return products.filter((product) =>
        product.ingredients.includes(selection[0].id)
      );
    } else {
      return products;
    }
  }

  const selectedProducts = section !== undefined ? select() : products;

  return (
    <>
      {section === 'ingredient' && <Description {...selection} />}
      <div className="products__contents-container">
        <div className="products__contents-wrapper">
          {selectedProducts.map((product) => (
            <div className="products__contents-individual">
              <Product
                section={section}
                selection={selection}
                product={product}
                key={product.id}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

const Description = (props) => {
  const ingredient = props[0];
  return (
    <div className="product__description-container">
      <div className="product__description-wrapper">
        <div className="product__description-content">
          <h2>{ingredient.description}</h2>
        </div>
      </div>
      <Accordion className="product__benefits-wrapper column">
        <Accordion.Toggle
          as={'div'}
          variant="link"
          eventKey="benefits"
          className="product__benefits-title"
        >
          <h2>- {ingredient.name}의 효능</h2>
        </Accordion.Toggle>
        <Accordion.Collapse
          eventKey="benefits"
          className="product__benefits-content"
        >
          <p>{ingredient.benefits}</p>
        </Accordion.Collapse>
        {ingredient.research && (
          <>
            <Accordion.Toggle
              as={'div'}
              variant="link"
              eventKey="research"
              className="product__research-title"
            >
              <h2>- 관련연구</h2>
            </Accordion.Toggle>
            <Accordion.Collapse
              eventKey="research"
              className="product__research-content"
            >
              <p>{ingredient.research}</p>
            </Accordion.Collapse>
          </>
        )}
      </Accordion>
    </div>
  );
};

export default Contents;
